import React, { useState } from 'react';
import { PageHeader } from '../layout/PageHeader';
import { useParams } from 'react-router-dom';

// Detalles de cada servicio
const serviceDetails = {
    'Landing page': {
        title: 'Landing page',
        subtitle: 'Creamos páginas de aterrizaje diseñadas para captar la atención de tus visitantes y convertirlos en clientes.',
        detail: (
            <>
                <p>
                    Una Landing Page efectiva es clave para aumentar conversiones y destacar tu marca.
                    Nuestro enfoque incluye:
                </p>
                <ul>
                    <li><i className="bi bi-check-circle"></i> Diseño atractivo y adaptado a la identidad de tu marca.</li>
                    <li><i className="bi bi-check-circle"></i> Optimización para dispositivos móviles.</li>
                    <li><i className="bi bi-check-circle"></i> Implementación de estrategias SEO para un mejor posicionamiento.</li>
                    <li><i className="bi bi-check-circle"></i> Integración de formularios y llamadas a la acción claras.</li>
                </ul>
                <p>
                    Trabajamos contigo desde el diseño hasta la implementación, garantizando que tu página cumpla con tus objetivos de negocio.
                </p>
            </>
        ),
    },
    'Proyectos personalizados': {
        title: 'Proyectos personalizados',
        subtitle: 'Desarrollamos soluciones a medida adaptadas a tus necesidades específicas.',
        detail: (
            <>
                <p>
                    Los proyectos personalizados son ideales cuando necesitas una solución que se adapte completamente a tu negocio. Ofrecemos:
                </p>
                <ul>
                    <li><i className="bi bi-check-circle"></i> Análisis inicial para comprender tus requerimientos.</li>
                    <li><i className="bi bi-check-circle"></i> Diseño y desarrollo de aplicaciones web o sistemas internos.</li>
                    <li><i className="bi bi-check-circle"></i> Integración con herramientas y APIs existentes.</li>
                    <li><i className="bi bi-check-circle"></i> Soporte y mantenimiento posterior al lanzamiento.</li>
                </ul>
                <p>
                    Desde una tienda en línea hasta un sistema de gestión, transformamos tus ideas en soluciones funcionales que impulsan tu negocio.
                </p>
            </>
        ),
    },
    'Desarrollo funcional': {
        title: 'Desarrollo funcional',
        subtitle: 'Mejoramos proyectos existentes añadiendo nuevas funcionalidades o optimizando las actuales.',
        detail: (
            <>
                <p>
                    Si ya cuentas con un proyecto y deseas mejorarlo, nuestro servicio de desarrollo funcional es la solución. ¿Qué ofrecemos?
                </p>
                <ul>
                    <li><i className="bi bi-check-circle"></i> Análisis de la arquitectura existente para identificar mejoras.</li>
                    <li><i className="bi bi-check-circle"></i> Implementación de nuevas características basadas en tus necesidades.</li>
                    <li><i className="bi bi-check-circle"></i> Optimización del rendimiento y reducción de tiempos de carga.</li>
                    <li><i className="bi bi-check-circle"></i> Actualización tecnológica para garantizar compatibilidad futura.</li>
                </ul>
                <p>
                    Este servicio es perfecto para empresas que buscan mantener sus soluciones al día sin necesidad de comenzar desde cero.
                </p>
            </>
        ),
    },
};

export const ServiceDetails = () => {
    const { id } = useParams('Landing page');
    const [activeService, setActiveService] = useState(serviceDetails[id] ? id : 'Landing page');

    return (
        <>
            <PageHeader title="Servicios Detalle" />
            <section id="service-details" className="service-details section">
                <div className="container">
                    <div className="row gy-4">
                        <div className='col-lg-12' data-aos="fade-up" data-aos-delay="100">
                            <h4>Explora nuestros servicios</h4>
                            <p>
                                Ofrecemos soluciones diseñadas para llevar tu proyecto al siguiente nivel,
                                desde la creación de páginas de aterrizaje atractivas hasta el
                                desarrollo de funcionalidades específicas para tus necesidades.
                            </p>
                        </div>
                        {/* Menú de servicios */}
                        <div className="col-lg-3" data-aos="fade-up" data-aos-delay="100">

                            <div className="services-list">
                                {Object.keys(serviceDetails).map((service) => (
                                    <button
                                        key={service}
                                        href="#"
                                        className={`btn  ${service === activeService ? 'text-primary-sc' : ''}`}
                                        onClick={(e) => {
                                            e.preventDefault();
                                            setActiveService(service);
                                        }}
                                    >
                                        {service}
                                    </button>
                                ))}
                            </div>
                        </div>

                        {/* Detalles del servicio seleccionado */}
                        <div className="col-lg-8" data-aos="fade-up" data-aos-delay="200">
                            <h3>{serviceDetails[activeService].title}</h3>
                            <h4>{serviceDetails[activeService].subtitle}</h4>
                            <div>{serviceDetails[activeService].detail}</div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
};
